import React from 'react'

 const Header = () => {
    return (
        <div className="header">
        <h2>WEATHER  APP </h2>
    </div>
    )
}


export default Header;